import Container from "@client/content/Containers/container";
import { Form } from "@client/content/controls";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type FormButtonProps, type FormFieldInfo } from "@client/controls/Form/component";
import { Status, type WithIsEditMode } from "@client/types";
import * as React from "react";
import { ModuleButton } from "../Button";
import { type CheckoutButton } from "./types";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    fields: FormFieldInfo[];

    status: string;

    product?: number | string;
  };

export interface ActionProps {
  onClick: (data: CheckoutButton.View.AddToCartFormData) => void;
}

export default (props: ActionProps & MapProps) => {
  const FormButton = (innerProps: FormButtonProps) => (
    <ModuleButton
      {...getRootContainerProps(props)}
      isDisabled={props.status === Status.Saving || !props.product}
      onClick={innerProps.ifValidated(props.onClick)}
    />
  );

  return (
    <Container className="wsc_content_checkout_button" {...getContainerProps(props)}>
      {(props.isEditMode || !!props.product) && (
        <Form {...getRootContainerProps(props)} fields={props.fields} Button={FormButton} />
      )}
    </Container>
  );
};
